import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon } from 'lucide-react';
import { buildTenantPath, extractTenantSlugFromPathname } from '../utils/tenantSlug';

const NotFoundPage = () => {
  const location = useLocation();
  const tenantSlug = extractTenantSlugFromPathname(location.pathname);

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-gray-50">
      <div className="text-center px-4">
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">Página não encontrada</h2>
        <p className="text-gray-600 mb-8">
          Desculpe, a página que você está procurando não existe ou foi movida.
        </p>
        <Link 
          to={buildTenantPath("/", tenantSlug)}
          className="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors duration-200"
        >
          <HomeIcon className="w-5 h-5 mr-2" />
          Voltar para Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
